import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StrideDistrictReportData } from '@mira-avant/mtlibs';
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
	selector: 'app-stride-district-report-summary',
	imports: [CommonModule, NzButtonModule, NzIconModule],
	standalone: true,
	templateUrl: './stride-district-report-summary.html',
	styleUrl: './stride-district-report-summary.scss',
})
export class StrideDistrictReportSummary {
	@Input('report') public report:StrideDistrictReportData | undefined;
}
